const translation = {
  // Top bar
  topBar: "한-베 B2B 수출 플랫폼 | Nền tảng B2B xuất khẩu Hàn Quốc → Việt Nam",

  // Navigation
  nav: {
    newProducts: "한국 신상품",
    newProductsVn: "신상품 목록",
    companies: "한국기업 소개",
    companiesVn: "기업 소개",
    techCoop: "기술협력",
    techCoopVn: "기술 협력",
    activities: "협회활동 소개",
    activitiesVn: "협회 활동",
    partner: "한국 파트너 신청",
    partnerVn: "파트너 신청",
    register: "무료회원 가입",
    registerVn: "무료 가입",
    searchPlaceholder: "상품명, 기업명 검색...",
    login: "로그인",
    allCategories: "전체",
    stats1: "382개 기업",
    stats2: "999+ 상품/카테고리",
    categoryMenu: "상품 카테고리",
    viewAllCount: "전체 보기",
    totalProducts: "총",
    inCategory: "개 상품",
    viewAllProducts: "전체 상품 보기 →",
    featured: "추천",
    newProductBanner: "신상품 안내",
    newProductBannerSub: "한국 주요 기업의 최신 상품을 매주 업데이트",
    exploreNow: "지금 보기",
  },

  // Hero Section
  hero: {
    announcement: "🇰🇷 한국 → 베트남 최고의 B2B 수출 플랫폼",
    title1: "한국 기업과",
    title2: "베트남 시장을 연결합니다",
    subtitle: "382개 이상의 한국 우수 기업의 첨단 기술 제품을 만나보세요. 베트남 시장을 위한 전문 B2B 플랫폼.",
    cta1: "상품 둘러보기",
    cta2: "무료 회원가입",
    stat1: "한국 기업",
    stat2: "상품 수",
    stat3: "베트남 파트너",
    stat4: "운영 년수",
  },

  // Category Grid
  category: {
    title: "상품 카테고리",
    subtitle: "한국의 8대 첨단 산업 분야",
    viewAll: "전체 보기",
    products: "개 상품",
  },

  // Featured Products
  featured: {
    title: "추천 상품",
    subtitle: "한국 주요 기업의 우수 상품을 엄선하였습니다",
    viewMore: "더 많은 상품 보기",
    new: "신상",
    hot: "인기",
    contactPrice: "가격 문의",
    viewDetail: "상세 보기",
    inquiry: "문의하기",
    comments: "댓글",
  },

  // Quick Access
  quickAccess: {
    flashSale: "특가 세일",
    newArrival: "신상품",
    topSeller: "베스트",
    certified: "인증 상품",
    partner: "파트너",
    techCoop: "기술협력",
    association: "협회",
    support: "지원",
  },

  // Stats
  stats: {
    title: "한-베 최고의 B2B 플랫폼",
    subtitle: "양국의 수많은 기업으로부터 신뢰받고 있습니다",
    companies: "한국 기업",
    products: "상품 수",
    partners: "베트남 파트너",
    years: "운영 기간",
  },

  // Product Detail
  product: {
    companyInfo: "기업 정보",
    companyCode: "기업 코드",
    managerCode: "담당자 코드",
    phone: "전화번호",
    email: "이메일",
    category: "카테고리",
    subCategory: "하위 카테고리",
    registeredDate: "등록일",
    tags: "태그",
    sendInquiry: "문의 보내기",
    price: "가격",
    description: "상품 설명",
    comments: "댓글 & 문의",
    addComment: "댓글 추가",
    yourName: "이름",
    yourComment: "댓글 또는 문의 내용을 입력하세요...",
    submit: "댓글 등록",
    adminReply: "관리자 답변",
    noComments: "아직 댓글이 없습니다. 첫 번째 댓글을 남겨보세요!",
    contactConsultation: "상담 문의",
    viewCompanyWebsite: "원본 상품 링크",
    contactZalo: "Zalo 채팅",
    registerConsultation: "상담 신청",
  },

  // Footer
  footer: {
    description: "한국 기업과 베트남 시장을 연결하는 B2B 플랫폼입니다. 첨단 기술 제품을 발견하고 전략적 파트너를 연결하세요.",
    quickLinks: "빠른 링크",
    categories: "카테고리",
    support: "지원",
    contactUs: "연락처",
    copyright: "© 2026 Vietnam B2B Korea. All rights reserved.",
    address: "주소",
    phone: "전화",
    email: "이메일",
  },

  // Common
  common: {
    viewAll: "전체 보기",
    loading: "로딩 중...",
    noResults: "검색 결과가 없습니다",
    search: "검색",
    filter: "필터",
    sort: "정렬",
    newest: "최신순",
    popular: "인기순",
    priceAsc: "가격 낮은순",
    priceDesc: "가격 높은순",
    page: "페이지",
    of: "/",
    results: "개 결과",
    perPage: "개씩 보기",
    contactPrice: "문의",
    products: "개 상품",
    companies: "개 기업",
  },
};

export default translation;
